<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import axios from 'axios';
import RbxConfirmDialog from '@/shared/reybex/RbxConfirmDialog';
import mainViewTabMixin from '@/mixins/mainViewTab';
import paginationMixin from '@/mixins/pagination';
import snackbarMixin from '@/mixins/snackbar';
import downloader from '@/mixins/downloader';
import TrainingListItem from './components/TrainingListItem';
import FinishTrainingDialog from './components/FinishTrainingDialog';
import MailErrorsDialog from './components/MailErrorsDialog';

export default {
  name: 'TrainingList',
  components: {
    TrainingListItem,
    RbxConfirmDialog,
    FinishTrainingDialog,
    MailErrorsDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin, snackbarMixin, downloader],
  data() {
    return {
      isInitialized: false,
      headers: [
        { text: 'Eingeladen', value: 'selected' },
        { text: 'Benutzername', value: 'username' },
        { text: 'Name', value: 'firstname' },
        { text: 'Vorname', value: 'surname' },
        { text: 'Email', value: 'email' },
        { text: 'Einladungsstatus', value: 'isInvited' },
        { text: 'Schulung abgschlossen', value: 'trainedDate' },
        { text: 'Geschult am', value: 'trainedDate' },
        { text: 'Aktionen', value: '' }],
      selected: [],
      isConfirmDialogDisplayed: false,
      isFinishTrainingDialogDisplayed: false,
      isRevertFinishTrainingDialogDisplayed: false,
      isLoading: false,
      searchTerm: '',
      listFilters: [
        { value: false, text: 'alle' },
        { value: 'active', text: 'aktive' },
        { value: 'inactive', text: 'inaktive' },
      ],
      selectedListFilter: {},
      mailErrorsDialog: {
        isVisible: false,
        mails: [],
      },
    };
  },
  computed: {
    ...mapState(['trainingList']),
    ...mapState('trainingList', ['meta']),
    ...mapGetters('app', ['auth']),
    filteredEmployees() {
      const filtered = [];

      if (this.trainingList.data && this.trainingList.data.length > 0) {
        this.trainingList.data.forEach((it) => {
          if (!it.isDelete || (it.isDelete && it.trainedDate)) {
            filtered.push(it);
          }
        });
      }

      return filtered;
    },
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });

    [this.selectedListFilter] = this.listFilters;
  },
  methods: {
    ...mapActions('trainingList', { fetchData: 'fetchTraineeList' }),
    ...mapActions('trainingList', ['downloadCsv']),
    inviteSelected() {
      if (this.selected.length > 0) {
        this.isConfirmDialogDisplayed = true;
      } else {
        this.showErrorMessage('Bitte selektieren Sie einen oder mehr Benutzer in der Tabelle.');
      }
    },
    finishTrainingSelected() {
      if (this.selected.length > 0) {
        this.isFinishTrainingDialogDisplayed = true;
      } else {
        this.showErrorMessage('Bitte selektieren Sie einen oder mehr Benutzer in der Tabelle.');
      }
    },
    revertFinishTrainingSelected() {
      if (this.selected.length > 0) {
        this.isRevertFinishTrainingDialogDisplayed = true;
      } else {
        this.showErrorMessage('Bitte selektieren Sie einen oder mehr Benutzer in der Tabelle.');
      }
    },
    async invite() {
      const usersWithEmail = this.selected
        .filter(it => it.email)
        .map(it => it.id);

      if (!usersWithEmail || usersWithEmail.length === 0) return;

      return axios.post('training/invite', { users: usersWithEmail })
        .then(({ data }) => {
          if (data.data.length) {
            this.mailErrorsDialog.mails = data.data;
            this.mailErrorsDialog.isVisible = true;
          }
          this.fetchData(this.paginationParams);
          this.showSuccessMessage('Die Einladungen wurden verschickt.');
        })
        .catch(() => {
          this.showErrorMessage('Die Einladungen konnten nicht verschickt werden.');
        });
    },
    finishTraining() {
      this.isLoading = true;
      const usersWithEmail = this.selected
        .filter(it => it.email)
        .map(it => it.id);

      if (!usersWithEmail || usersWithEmail.length === 0) return;

      axios.post('training/finish', { users: usersWithEmail })
        .then(() => {
          this.fetchData(this.paginationParams);
          this.showSuccessMessage('Die Schulungen wurden abgeschlossen.');
        }).catch(() => {
          this.showErrorMessage('Die Schulungen konnten nicht abgeschlossen werden.');
        })
        .finally(() => {
          this.isFinishTrainingDialogDisplayed = false;
          this.isLoading = false;
        });
    },
    revertFinishTraining() {
      this.isLoading = true;
      const selectedIds = this.selected
        .map(it => it.id);


      axios.post('training/revertFinish', { users: selectedIds })
        .then(() => {
          this.fetchData(this.paginationParams);
          this.showSuccessMessage('Die Schulungen wurden wieder auf offen gesetzt.');
        }).catch(() => {
          this.showErrorMessage('Die Schulungen konnten nicht auf offen gesetzt werden.');
        })
        .finally(() => {
          this.isRevertFinishTrainingDialogDisplayed = false;
          this.isLoading = false;
        });
    },
    async getLoginDataSheet() {
      const usersWithoutEmail = this.selected
        .filter(it => !it.email)
        .map(it => it.id);
      const self = this;

      if (!usersWithoutEmail || usersWithoutEmail.length === 0) return;

      return this.downloadWithParams({
        url: 'training/loginDataSheet',
        method: 'post',
        data: { users: usersWithoutEmail },
        fileName: 'Logindaten.pdf',
      }).then(() => {
        self.fetchData(self.paginationParams);
      });
    },
    async onConfirm() {
      const self = this;
      this.isLoading = true;

      try {
        await this.invite();

        try {
          await this.getLoginDataSheet();
        } catch (e) {
          self.showErrorMessage('Die PDF-Datein für die Zugangsdaten konnten nicht erstellt werden.');
          throw e;
        }
      } catch (e) {
        throw e;
      } finally {
        self.isConfirmDialogDisplayed = false;
        self.isLoading = false;
      }
    },
    async onConfirmFinishTraining() {
      this.finishTraining();
    },
    async onConfirmRevertFinishTraining() {
      this.revertFinishTraining();
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
      this.isFinishTrainingDialogDisplayed = false;
      this.isRevertFinishTrainingDialogDisplayed = false;
    },
    setSelected(user) {
      let index = 0;
      let isUserFound = false;

      while (index < this.selected.length) {
        if (this.selected[index].id === user.id) {
          isUserFound = true;
          break;
        } else {
          index += 1;
        }
      }

      if (isUserFound) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(user);
      }
    },
    onSearch() {
      const options = { ...this.paginationParams };

      if (this.searchTerm) {
        options.searchTerm = this.searchTerm;
      }

      if (this.selectedListFilter.value) {
        options.activeTerm = this.selectedListFilter.value;
      }

      this.fetchData(options);
    },
    refresh() {
      this.resetSearchOptions();
      this.fetchData(this.paginationParams);
    },
    resetSearchOptions() {
      this.searchTerm = '';
      [this.selectedListFilter] = this.listFilters;
    },
    onDownloadCsv() {
      const ids = this.selected.map(item => item.id);

      const params = {
        ids,
        isExport: 1,
      };

      this.downloadCsv(params)
        .then((response) => {
          console.log('response', response);
          const objectUrl = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = objectUrl;
          link.setAttribute('download', 'file.csv');
          document.body.appendChild(link);
          link.click();
        });
    },
  },
};
</script>

<template>
  <div class="training-list">
    <template v-if="trainingList.hasError">
      <p class="js-error-template ma-3">Failed to fetch user list. Please try again!</p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottom>
          <v-btn @click.native="inviteSelected" flat icon slot="activator" >
            <v-icon small>person_add</v-icon>
          </v-btn>
          <span>Ausgewählte Mitarbeiter zur Schulung einladen</span>
        </v-tooltip>
        <v-tooltip v-if="auth.hasDeleteRights" bottom>
          <v-btn @click.native="finishTrainingSelected" flat icon slot="activator" >
            <v-icon small>check</v-icon>
          </v-btn>
          <span>Schulung für ausgewählte Mitarbeiter abschließen</span>
        </v-tooltip>
        <v-tooltip v-if="auth.hasDeleteRights" bottom>
          <v-btn @click.native="revertFinishTrainingSelected" flat icon slot="activator" >
            <v-icon small>close</v-icon>
          </v-btn>
          <span>Schulung für ausgewählte Mitarbeiter wieder auf offen setzen</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn @click="onSearch" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn slot="activator" :disabled="!selected.length" icon @click="onDownloadCsv">
            <v-icon>cloud_download</v-icon>
          </v-btn>
          <span>Bericht herunterladen</span>
        </v-tooltip>
        <v-spacer />
        <v-flex md3 >
          <v-text-field
            v-model="searchTerm"
            label="Suche"
            height="22"
            class="caption"
            @keyup.enter="onSearch"
            @blur="onSearch"
          />
        </v-flex>
      </v-toolbar>

      <v-layout row wrap>
        <v-flex xs4 md2>
          <v-select
            v-model="selectedListFilter"
            :items="listFilters"
            item-value="id"
            item-text="text"
            label="Filter"
            style="padding-left: 24px; padding-top: 24px;"
            return-object
            @change="onSearch"
          />
        </v-flex>
      </v-layout>

      <v-progress-linear
        v-if="trainingList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        v-model="selected"
        :headers="headers"
        :items="filteredEmployees"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="trainingList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="username"
        select-all
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        no-results-text="keine Einträge gefunden"
        class="elevation-1 js-table"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable',
                       pagination.descending ? 'desc' : 'asc',
                       header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value, trainingList.data)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <training-list-item
            :user="props.item"
            :selected="props.selected"
            :expanded="props.expanded"
            @setSelected="setSelected({id: props.item.id, email: props.item.email})" />
        </template>
        <template slot="pageText" scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>

    <rbx-confirm-dialog
      @confirm="onConfirm" @refuse="onRefuse"
      :message="'Sollen die selektierten Mitarbeiter zur Schulung eingeladen werden?'"
      :is-displayed="isConfirmDialogDisplayed"
      :is-loading="isLoading"
    />

    <rbx-confirm-dialog
      @confirm="onConfirmFinishTraining" @refuse="onRefuse"
      :message="'Soll die Schulung für die selektierten Mitarbeiter abgeschlossen werden?'"
      :is-displayed="isFinishTrainingDialogDisplayed"
      :is-loading="isLoading"
    />

    <rbx-confirm-dialog
      @confirm="onConfirmRevertFinishTraining" @refuse="onRefuse"
      :message="`Soll die Schulung für dieselektierten
                  Mitarbeiter wieder auf offen gesetzt werden?`"
      :is-displayed="isRevertFinishTrainingDialogDisplayed"
      :is-loading="isLoading"
    />

    <mail-errors-dialog
      v-if="mailErrorsDialog.isVisible"
      :mails="mailErrorsDialog.mails"
      @close="mailErrorsDialog.isVisible = false"
    />
  </div>
</template>

<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
